import { createBrowserRouter } from 'react-router-dom';

import { mainRoutes } from './mainRoutes';

export const router = createBrowserRouter(mainRoutes);
